import { render } from "./CoBrandFolio.vue?vue&type=template&id=90c0969e&scoped=true"
import script from "./CoBrandFolio.vue?vue&type=script&lang=js"
export * from "./CoBrandFolio.vue?vue&type=script&lang=js"

import "./CoBrandFolio.vue?vue&type=style&index=0&id=90c0969e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c0969e"]])

export default __exports__